import React from 'react';

import Styled from './ButtonLink.styles';

type Props = {
  onClick?: () => void;
  underlined?: boolean;
  disabled?: boolean;
  fontSize?: string;
  children: React.ReactNode;
};
const ButtonLink: React.FC<Props> = (props: Props) => {
  const {
    children,
    onClick,
    disabled,
    fontSize,
    underlined,
  } = props;

  return (
    <Styled.ButtonLink
      onClick={onClick}
      disabled={disabled}
      style={{
        textDecoration: `${underlined ? 'underline' : 'None'}`,
        fontSize: `${fontSize || '14px'}`,
      }}
    >
      {children}
    </Styled.ButtonLink>
  );
};

export default ButtonLink;
